const _excluded = ["templates", "thesauris", "settings", "excludePreview"],_excluded2 = ["additionalMetadata", "sortedProperty", "entity", "relationships", "useV2Player", "excludePreview"];function _extends() {return _extends = Object.assign ? Object.assign.bind() : function (n) {for (var e = 1; e < arguments.length; e++) {var t = arguments[e];for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);}return n;}, _extends.apply(null, arguments);}function _objectWithoutProperties(e, t) {if (null == e) return {};var o,r,i = _objectWithoutPropertiesLoose(e, t);if (Object.getOwnPropertySymbols) {var s = Object.getOwnPropertySymbols(e);for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);}return i;}function _objectWithoutPropertiesLoose(r, e) {if (null == r) return {};var t = {};for (var n in r) if ({}.hasOwnProperty.call(r, n)) {if (e.includes(n)) continue;t[n] = r[n];}return t;}import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';
import Immutable from 'immutable';
import { metadataSelectors } from "../selectors";
import Metadata from "../components/Metadata";

const removeUneededProps = (_ref) => {let { templates, thesauris, settings, excludePreview } = _ref,rest = _objectWithoutProperties(_ref, _excluded);return rest;};

const BaseFormatMetadata = (_ref2) =>







{let { additionalMetadata = [], sortedProperty = '', entity, relationships = Immutable.fromJS([]), useV2Player = false, excludePreview = false } = _ref2,props = _objectWithoutProperties(_ref2, _excluded2);
  const { attachments } = entity;

  return (/*#__PURE__*/
    React.createElement(Metadata, _extends({
      metadata: additionalMetadata.concat(
        metadataSelectors.formatMetadata(props, entity, sortedProperty, relationships, {
          excludePreview
        })
      ),
      attachments: attachments,
      templateId: entity.template,
      compact: !!sortedProperty,
      useV2Player: useV2Player },
    removeUneededProps(props))
    ));

};




























export function mapStateToProps(state, { entity, sortedProperty = '' }) {
  return {
    templates: state.templates,
    thesauris: state.thesauris,
    settings: state.settings.collection,
    entity,
    sortedProperty
  };
}

export const FormatMetadata = connect(mapStateToProps)(BaseFormatMetadata);